@let buildingIdValue = buildingId();
@if (showTitle()) {
  @let hasBuildingScenariosLicenseValue = hasBuildingScenariosLicense();
  <h2 [class]="titleClass()" [class.d-flex]="hasBuildingScenariosLicenseValue">
    <span [innerHtml]="'measures' | translate"></span>
    @if (hasEnergyLabelTranslation('building.measures.intro')) {
      <cfp-info-modal-button
        class="ms-2"
        [title]="'measures'"
        [body]="getEnergyLabelTranslationKey('building.measures.intro')"
      />
    }
    @if (hasBuildingScenariosLicenseValue && buildingIdValue) {
      @defer {
        <cfp-building-scenarios-button class="ms-auto" [buildingId]="buildingIdValue" />
      }
    }
  </h2>
  <hr aria-hidden="true" />
}
@if (showBody()) {
  <p class="mb-4">
    <cfp-translated-router-link
      [text]="getEnergyLabelTranslationKey('building.measure.overview.body')"
      [interpolateParams]="{ labelGroupRating: (`labelGroup.rating.${labelGroup()}` | translate) }"
      [link]="`/${module()}/${portfolioId()}/buildings/${buildingId()}/properties`"
    />
  </p>
}

@let hasErrorValue = hasError();
@let initialLoadingValue = initialLoading();
<cfp-loading-spinner [loading]="initialLoadingValue" [error]="hasErrorValue" />

@if (!initialLoadingValue && !hasErrorValue) {
  @let showM2Value = showM2();
  @let licensesValue = licenses();
  @let labelGroupValue = labelGroup();
  @let labelGroupsValue = labelGroups();
  @if (showScenarios()) {
    <div class="row d-print-none">
      <div class="col-12 col-sm-auto mb-3 d-flex align-items-center building-measures-scenarios">
        <cfp-button-toggle
          [pressed]="isScenarioActive('allMeasures')"
          [buttonSize]="'small'"
          [pressedButtonStyle]="'primary'"
          [buttonOutline]="!isScenarioActive('allMeasures')"
          (clicked)="changeScenario('allMeasures')"
          [classes]="'me-2'"
        >
          {{ 'scenario.allmeasures' | translate }}
        </cfp-button-toggle>
        @if (plannedMeasuresCount() > 0) {
          <cfp-button-toggle
            [pressed]="isScenarioActive('planned')"
            [buttonSize]="'small'"
            [pressedButtonStyle]="'primary'"
            [buttonOutline]="!isScenarioActive('planned')"
            (clicked)="changeScenario('planned')"
            [classes]="'me-2'"
          >
            {{ 'scenario.planned' | translate }}
          </cfp-button-toggle>
        }
        @if (hasCustomerMeasures()) {
          <cfp-button-toggle
            [pressed]="isScenarioActive('customerMeasures')"
            [buttonSize]="'small'"
            [pressedButtonStyle]="'primary'"
            [buttonOutline]="!isScenarioActive('customerMeasures')"
            (clicked)="changeScenario('customerMeasures')"
            [classes]="'me-2'"
          >
            {{ 'scenario.customer' | translate }}
          </cfp-button-toggle>
        }
        @if (environment.components.scenarioFiveYear) {
          <cfp-button-toggle
            [pressed]="isScenarioActive('fiveYear')"
            [buttonSize]="'small'"
            [pressedButtonStyle]="'primary'"
            [buttonOutline]="!isScenarioActive('fiveYear')"
            (clicked)="changeScenario('fiveYear')"
            [classes]="'me-2'"
          >
            {{ 'scenario.fiveyear' | translate }}
          </cfp-button-toggle>
        }
      </div>
      <div class="col-12 col-md-4 ms-0 ms-sm-auto justify-content-start justify-content-sm-end">
        @if (canSeeBudgeting()) {
          <cfp-button
            (clicked)="showBudgetingModal()"
            [buttonSize]="'small'"
            [buttonOutline]="true"
            [buttonStyle]="'secondary'"
            class="d-flex"
            classes="ms-0 mb-4 ms-sm-auto"
          >
            {{ 'budgeting.setBudget.button' | translate }}
          </cfp-button>
        }
      </div>
    </div>
  }
  @if (showToolbar()) {
    <div class="toolbar card-row d-print-none">
      <div class="row row-condensed card-padding-x">
        <div class="col-12 col-sm order-1 toolbar-search-col mb-3 mb-lg-0" #dataTableSearch>
          <lib-data-table-search [searchText]="searchText()" (searchChange)="search($event)" />
        </div>
        <div>
          @let filterBadgesValue = filterBadges();
          <div class="row g-2">
            @for (item of filterBadgesValue; let index = $index; track item) {
              <cfp-filter-badge (clicked)="removeFilterBadge(index)" class="col-auto" [label]="item.display" />
            }
            @if (filterBadgesValue.length > 0) {
              <hr class="d-block" />
            }
          </div>
        </div>
        <div class="col-12 col-lg-auto order-3">
          @let filtersActiveValue = filtersActive();
          <div
            class="filter-group input-group-3 input-group-sm"
            [class.input-group]="!filtersActiveValue"
            [class.btn-group]="filtersActiveValue"
            [class.btn-group-sm]="filtersActiveValue"
            (click)="showFilters()"
          >
            <button
              type="button"
              class="order-2 text-start"
              [class.form-control]="!filtersActiveValue"
              [class.btn]="filtersActiveValue"
              [class.btn-primary]="filtersActiveValue"
              [attr.aria-expanded]="filtersActiveValue ? 'true' : 'false'"
            >
              {{ 'filter' | translate }}
            </button>
            <span
              class="order-1"
              [class.input-group-text]="!filtersActiveValue"
              [class.btn]="filtersActiveValue"
              [class.btn-primary]="filtersActiveValue"
            >
              <i class="fa fa-filter" aria-hidden="true"></i>
            </span>
            <span
              (click)="clearFilters($event)"
              class="order-3"
              [class.input-group-text]="!filtersActiveValue"
              [class.btn]="filtersActiveValue"
              [class.btn-primary]="filtersActiveValue"
            >
              <i class="fa fa-times" aria-hidden="true" [class.opacity-0]="!filtersActiveValue"></i>
            </span>
          </div>
        </div>
        <div class="col-12 col-lg-auto order-4 mt-3 mt-lg-0">
          @let objectiveValue = objective();
          <cfp-select
            [ngModel]="objectiveValue"
            (ngModelChange)="changeObjective($event)"
            [name]="'objective'"
            [formControlSize]="'small'"
            [placeholder]="!objectiveValue ? ('objective.choose' | translate) : undefined"
            [ariaLabel]="!objectiveValue ? ('objective.choose' | translate) : ('objective.none' | translate)"
          >
            @if (objectiveValue) {
              <cfp-option [value]="undefined" [label]="'objective.none' | translate" />
            }
            <cfp-option
              [value]="BuildingMeasuresOverviewObjective.CostReduction"
              [label]="'objective.costReduction' | translate"
            />
            <cfp-option
              [value]="BuildingMeasuresOverviewObjective.Co2Reduction"
              [label]="'objective.co2Reduction' | translate"
            />
            @if (!(labelGroupsValue?.length === 1 && labelGroupValue === LabelGroupDTO.CARBONSCORE)) {
              <cfp-option
                [value]="BuildingMeasuresOverviewObjective.ImproveEnergyLabel"
                [label]="
                  'objective.improveEnergyLabel'
                    | translate: { labelGroupRating: `labelGroup.rating.${mainLabelGroup()}` | translate }
                "
              />
            }
            @if (environment.components.showRecognisedMeasureCheck) {
              <cfp-option
                [value]="BuildingMeasuresOverviewObjective.ComplyLawRegulations"
                [label]="'objective.complyLawRegulations' | translate"
              />
            }
            @if (environment.components.showImplementationOrder) {
              <cfp-option
                [value]="BuildingMeasuresOverviewObjective.ImplementationOrder"
                [label]="'objective.implementationOrder' | translate"
              />
            }
          </cfp-select>
        </div>

        @if (showOptionsDropdown()) {
          <div class="col-auto ms-auto order-2 order-lg-5 mb-3">
            <cfp-dropdown
              [icon]="'ellipsis-v'"
              [formControlSize]="'small'"
              class="cfp-dropdown-options"
              [id]="'selectLabelGroup'"
              [ariaLabel]="'actions' | translate"
            >
              @if (labelGroupsValue && labelGroupsValue.length > 1) {
                <div class="dropdown-title">{{ 'rating' | translate }}</div>
                <cfp-radio-label-group
                  [labelGroups]="labelGroupsValue"
                  [labelGroup]="labelGroupValue"
                  (labelGroupChange)="labelGroup.set($event)"
                />
              }
              @if (showM2InDropdown()) {
                @if (labelGroupsValue && labelGroupsValue.length > 1) {
                  <div class="divider dropdown-divider"></div>
                }
                <div class="dropdown-title">{{ 'show' | translate }}</div>
                <cfp-input-radio
                  [radioValue]="false"
                  [name]="'showM2'"
                  [id]="'showM2True'"
                  [ngModel]="showM2Value"
                  (ngModelChange)="setShowM2(false)"
                  [label]="'totals' | translate"
                />
                <cfp-input-radio
                  [radioValue]="true"
                  [name]="'showM2'"
                  [id]="'showM2False'"
                  [ngModel]="showM2Value"
                  (ngModelChange)="setShowM2(true)"
                  [label]="'dividedByArea' | translate"
                />
              }
              @if (canResetMeasures()) {
                @if ((labelGroupsValue && labelGroupsValue.length > 1) || showM2InDropdown()) {
                  <div class="divider dropdown-divider"></div>
                }
                <div class="dropdown-title">{{ 'actions' | translate }}</div>
                <button type="button" class="dropdown-item" (click)="resetMeasuresToOutOfScope()">
                  {{ 'building.resetMeasures.outOfScope.button' | translate }}
                </button>
                <button type="button" class="dropdown-item" (click)="resetMeasuresToDefault()">
                  {{ 'building.resetMeasures.default.button' | translate }}
                </button>
                @if (canExport() && licensesValue.export_to_excel) {
                  <div class="divider dropdown-divider"></div>
                }
              }
              @if (canExport() && licensesValue.export_to_excel) {
                <div class="dropdown-title">{{ 'export' | translate }}</div>
                <button (click)="export()" class="dropdown-item cursor-pointer">
                  <cfp-icon [icon]="'file-excel'" [classes]="'me-2'" />
                  {{ 'export.excel' | translate }}
                </button>
              }
            </cfp-dropdown>
          </div>
        } @else {
          <div class="col-auto order-lg-4 order-2">
            @if (environment.components.savingsM2) {
              <div actions class="btn-group toggle-btn-group d-print-none">
                <cfp-button-toggle
                  [id]="'showM2'"
                  (clicked)="setShowM2(!showM2Value)"
                  [ariaLabel]="'aria.label.toggleSquareUnit' | translate"
                  [pressed]="showM2Value"
                  [buttonSize]="'small'"
                >
                  <cfp-measurement-area />
                </cfp-button-toggle>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }

  @let showEnergyIconValue = showEnergyIcon();
  @let canEditMeasureValue = canEditMeasure();
  @let currencyCodeValue = currencyCode();
  @let showAsCardValue = showAsCard();
  @let isPdfServiceRequestValue = isPdfServiceRequest();
  @let measuresWithBadgeValue = measuresWithBadge();
  @let filteredBuildingMeasuresValue = filteredBuildingMeasures();
  @let buildingValue = building();
  @let buildingAddress = buildingValue?.address;
  @let showColumnsValue = showColumns();
  @if (showTable() && buildingValue && buildingAddress) {
    <lib-data-table
      [columns]="columns()"
      [data]="filteredBuildingMeasuresValue"
      [usePaging]="false"
      [sortBy]="sortBy()"
      [sortOrder]="sortOrder()"
      [loading]="loading()"
      [rememberStateId]="rememberStateId()"
      (sortByChange)="setSortBy($event)"
      (sortOrderChange)="setSortOrder($event)"
      [tableClass]="tableClass()"
      data-test="buildingMeasuresTable"
      [useStickyHeader]="isPdfServiceRequestValue ? false : true"
      [useStickyColumns]="isPdfServiceRequestValue ? false : useStickyColumns()"
      [headersNoWrap]="true"
      [ariaLabelledby]="tableAriaLabelledby()"
      [showAsCard]="showAsCardValue"
      #dataTable
    >
      <ng-template let-item="item" let-index="index">
        @let measure = getTypedMeasure(item);
        <tr
          [ngClass]="{ open: openMeasureCode() === measure.code, odd: index % 2 === 0 }"
          (click)="canEditMeasureValue && onRowClick(measure, index, row)"
          [attr.data-test]="`buildingMeasure_${measure.code}`"
          #row
        >
          <td [ngClass]="{ 'cursor-pointer': canEditMeasureValue, 'cursor-default': !canEditMeasureValue }">
            <button
              class="d-flex building-measure-item-name"
              (keyup.enter)="canEditMeasureValue && onRowClick(measure, index, row)"
            >
              @if (measure.icon && measure.name) {
                <cfp-text-wrap-with-content [text]="measure.name" [title]="measure.name">
                  <span
                    [ngClass]="measure.icon"
                    [attr.title]="measure.iconTitle ? (measure.iconTitle | translate) : undefined"
                  ></span>
                </cfp-text-wrap-with-content>
              } @else if (measure.name && measure.code && hasSubsidyLicense() && shouldShowSubsidyIcon(measure.code)) {
                <cfp-text-wrap-with-content [text]="measure.name" [title]="measure.name">
                  @defer {
                    <cfp-subsidy-measure-icon [buildingId]="buildingIdValue!" [measureCode]="measure.code" />
                  }
                </cfp-text-wrap-with-content>
              } @else {
                {{ measure.name }}
                @if (measuresWithBadgeValue && measure.code && measuresWithBadgeValue[measure.code]) {
                  <cfp-badge> {{ measuresWithBadgeValue[measure.code] | translate }} </cfp-badge>
                }
              }
            </button>
          </td>
          @if (showColumnsValue.energyUsage) {
            <td>
              @if (showM2Value) {
                @if (measure.electricityConsumptionReductionInKwh) {
                  @if (showEnergyIconValue) {
                    <cfp-icon [icon]="'bolt'" class="me-2" />
                  }
                  <cfp-measurement-kwh-per-square
                    [title]="
                      (measure.electricityConsumptionReductionInKwh > 0
                        ? 'energyUsage.electricity.decrease'
                        : 'energyUsage.electricity.increase'
                      ) | translate
                    "
                    class="d-block text-nowrap"
                    [value]="measure.electricityConsumptionReductionInKwhM2"
                  />
                }
                @if (measure.gasConsumptionReductionInM3 && measure.gasConsumptionReductionInM3 > 0) {
                  @if (showEnergyIconValue) {
                    <cfp-icon [icon]="'fire'" class="me-2" />
                  }
                  <cfp-measurement-gas-per-square
                    [building]="buildingValue"
                    class="d-block text-nowrap"
                    [title]="
                      (measure.gasConsumptionReductionInM3 > 0
                        ? 'energyUsage.gas.decrease'
                        : 'energyUsage.gas.increase'
                      ) | translate: { unit: this.unitsConversionHelper.gasUnitsText() }
                    "
                    [value]="measure.gasConsumptionReductionInM3M2"
                  />
                }
                @if (measure.heatConsumptionReductionInGJ && measure.heatConsumptionReductionInGJ > 0) {
                  @if (showEnergyIconValue) {
                    <cfp-icon [icon]="'heat'" class="me-2" />
                  }
                  <cfp-measurement-heat-per-square
                    [building]="buildingValue"
                    [title]="
                      (measure.heatConsumptionReductionInGJ > 0
                        ? 'energyUsage.heat.decrease'
                        : 'energyUsage.heat.increase'
                      ) | translate: { unit: this.unitsConversionHelper.heatUnits() }
                    "
                    class="d-block text-nowrap"
                    [value]="measure.heatConsumptionReductionInGJM2"
                  />
                }
              }
              @if (!showM2Value) {
                @if (measure.electricityConsumptionReductionInKwh) {
                  <div
                    class="text-nowrap"
                    [title]="
                      (measure.electricityConsumptionReductionInKwh > 0
                        ? 'energyUsage.electricity.decrease'
                        : 'energyUsage.electricity.increase'
                      ) | translate
                    "
                  >
                    @if (showEnergyIconValue) {
                      <cfp-icon [icon]="'bolt'" class="me-2" />
                    }
                    {{ measure.electricityConsumptionReductionInKwh | number: '1.0-0' }} kWh
                    <i
                      class="fa ms-2"
                      [ngClass]="{
                        'fa-long-arrow-down text-success': measure.electricityConsumptionReductionInKwh > 0,
                        'fa-long-arrow-up text-danger': measure.electricityConsumptionReductionInKwh < 0
                      }"
                    ></i>
                  </div>
                }
                @if (measure.gasConsumptionReductionInM3 && measure.gasConsumptionReductionInM3 > 0) {
                  <div
                    class="text-nowrap"
                    [tooltip]="
                      (measure.gasConsumptionReductionInM3 > 0
                        ? 'energyUsage.gas.decrease'
                        : 'energyUsage.gas.increase'
                      ) | translate: { unit: this.unitsConversionHelper.gasUnitsText() }
                    "
                  >
                    @if (showEnergyIconValue) {
                      <cfp-icon [icon]="'fire'" class="me-2" />
                    }
                    {{
                      measure.gasConsumptionReductionInM3
                        | gasUnitsConversion: buildingAddress.countryCode : buildingAddress.regionCode
                        | async
                        | number: '1.0-0'
                    }}
                    <span [innerHTML]="unitsConversionHelper.gasUnitsHtml()"></span>
                    <i
                      class="fa ms-2"
                      [ngClass]="{
                        'fa-long-arrow-down text-success': measure.gasConsumptionReductionInM3 > 0,
                        'fa-long-arrow-up text-danger': measure.gasConsumptionReductionInM3 < 0
                      }"
                    ></i>
                  </div>
                }
                @if (measure.heatConsumptionReductionInGJ && measure.heatConsumptionReductionInGJ > 0) {
                  <div
                    class="text-nowrap"
                    [title]="
                      (measure.heatConsumptionReductionInGJ > 0
                        ? 'energyUsage.heat.decrease'
                        : 'energyUsage.heat.increase'
                      ) | translate: { unit: this.unitsConversionHelper.heatUnits() }
                    "
                  >
                    @if (showEnergyIconValue) {
                      <cfp-icon [icon]="'heat'" class="me-2" />
                    }
                    {{
                      measure.heatConsumptionReductionInGJ
                        | heatUnitsConversion: buildingAddress.countryCode : buildingAddress.regionCode
                        | async
                        | number: '1.0-0'
                    }}
                    {{ unitsConversionHelper.heatUnits() }}
                    <i
                      class="fa ms-2"
                      [ngClass]="{
                        'fa-long-arrow-down text-success': measure.heatConsumptionReductionInGJ > 0,
                        'fa-long-arrow-up text-danger': measure.heatConsumptionReductionInGJ < 0
                      }"
                    ></i>
                  </div>
                }
                @if (measure.oilConsumptionReductionInLiter && measure.oilConsumptionReductionInLiter > 0) {
                  <div
                    class="text-nowrap"
                    [title]="
                      (measure.oilConsumptionReductionInLiter > 0
                        ? 'energyUsage.oil.decrease'
                        : 'energyUsage.oil.increase'
                      ) | translate: { unit: this.unitsConversionHelper.oilUnits() }
                    "
                  >
                    @if (showEnergyIconValue) {
                      <cfp-icon [icon]="'oil-can'" class="me-2" />
                    }
                    {{
                      measure.oilConsumptionReductionInLiter
                        | oilUnitsConversion: buildingAddress.countryCode : buildingAddress.regionCode
                        | async
                        | number: '1.0-0'
                    }}
                    L
                    <i
                      class="fa ms-2"
                      [ngClass]="{
                        'fa-long-arrow-down text-success': measure.oilConsumptionReductionInLiter > 0,
                        'fa-long-arrow-up text-danger': measure.oilConsumptionReductionInLiter < 0
                      }"
                    ></i>
                  </div>
                }
                @if (measure.coalConsumptionReductionInTons && measure.coalConsumptionReductionInTons > 0) {
                  <div
                    class="text-nowrap"
                    [title]="
                      (measure.coalConsumptionReductionInTons > 0
                        ? 'energyUsage.coal.decrease'
                        : 'energyUsage.coal.increase'
                      ) | translate: { unit: this.unitsConversionHelper.coalUnits() }
                    "
                  >
                    @if (showEnergyIconValue) {
                      <cfp-icon [icon]="'fire'" class="me-2" />
                    }
                    {{
                      measure.coalConsumptionReductionInTons
                        | coalUnitsConversion: buildingAddress.countryCode : buildingAddress.regionCode
                        | async
                        | number: '1.0-3'
                    }}
                    t
                    <i
                      class="fa ms-2"
                      [ngClass]="{
                        'fa-long-arrow-down text-success': measure.coalConsumptionReductionInTons > 0,
                        'fa-long-arrow-up text-danger': measure.coalConsumptionReductionInTons < 0
                      }"
                    ></i>
                  </div>
                }
                @if (measure.woodConsumptionReductionInM3 && measure.woodConsumptionReductionInM3 > 0) {
                  <div
                    class="text-nowrap"
                    [title]="
                      (measure.woodConsumptionReductionInM3 > 0
                        ? 'energyUsage.wood.decrease'
                        : 'energyUsage.wood.increase'
                      ) | translate: { unit: this.unitsConversionHelper.woodUnitsText() }
                    "
                  >
                    @if (showEnergyIconValue) {
                      <cfp-icon [icon]="'fire'" class="me-2" />
                    }
                    {{
                      measure.woodConsumptionReductionInM3
                        | woodUnitsConversion: buildingAddress.countryCode : buildingAddress.regionCode
                        | async
                        | number: '1.0-3'
                    }}
                    M3
                    <i
                      class="fa ms-2"
                      [ngClass]="{
                        'fa-long-arrow-down text-success': measure.woodConsumptionReductionInM3 > 0,
                        'fa-long-arrow-up text-danger': measure.woodConsumptionReductionInM3 < 0
                      }"
                    ></i>
                  </div>
                }
                @if (measure.pelletConsumptionReductionInTons && measure.pelletConsumptionReductionInTons > 0) {
                  <div
                    class="text-nowrap"
                    [title]="
                      (measure.pelletConsumptionReductionInTons > 0
                        ? 'energyUsage.pellet.decrease'
                        : 'energyUsage.pellet.increase'
                      ) | translate: { unit: this.unitsConversionHelper.pelletUnits() }
                    "
                  >
                    @if (showEnergyIconValue) {
                      <cfp-icon [icon]="'fire'" class="me-2" />
                    }
                    {{
                      measure.pelletConsumptionReductionInTons
                        | pelletUnitsConversion: buildingAddress.countryCode : buildingAddress.regionCode
                        | async
                        | number: '1.0-3'
                    }}
                    Tons
                    <i
                      class="fa ms-2"
                      [ngClass]="{
                        'fa-long-arrow-down text-success': measure.pelletConsumptionReductionInTons > 0,
                        'fa-long-arrow-up text-danger': measure.pelletConsumptionReductionInTons < 0
                      }"
                    ></i>
                  </div>
                }
              }
            </td>
          }
          @if (showColumnsValue.costReduction) {
            <td class="text-nowrap">
              @if (showM2Value) {
                <cfp-measurement-cost-per-square
                  [value]="measure.costReductionM2"
                  [sourceCurrencyCode]="currencyCodeValue"
                />
              } @else {
                {{
                  measure.costReduction
                    | cfpCurrency: currencyCodeValue : environment.currencyDisplay || 'symbol-narrow'
                }}
              }
              @if (
                showCalculatedValueIcon &&
                measure.buildingMeasureType === BuildingMeasureTypeDTO.CALCULATED &&
                !measure.userDefinedCostReduction
              ) {
                <cfp-icon
                  class="icon-calculated-value ms-2"
                  [icon]="'magnifying-glass-chart'"
                  [tooltip]="'measure.valueCalculated' | translate"
                />
              }
            </td>
          }
          @if (showColumnsValue.investment) {
            <td class="text-nowrap">
              @if (showM2Value) {
                <cfp-measurement-cost-per-square
                  [value]="measure.investmentM2"
                  [sourceCurrencyCode]="currencyCodeValue"
                />
              } @else {
                {{
                  measure.investment | cfpCurrency: currencyCodeValue : environment.currencyDisplay || 'symbol-narrow'
                }}
              }
              @if (showVat() && licensesValue.vat && measure.percentageVAT !== null) {
                <cfp-badge
                  [tooltip]="'percentage.VAT.tooltip' | translate: { percentage: measure.percentageVAT }"
                  [badgeStyle]="'secondary'"
                  >{{ 'percentage.VAT.display' | translate: { percentage: measure.percentageVAT } }}
                </cfp-badge>
              }
              @if (
                showCalculatedValueIcon &&
                measure.buildingMeasureType === BuildingMeasureTypeDTO.CALCULATED &&
                !measure.userDefinedInvestment
              ) {
                <cfp-icon
                  class="icon-calculated-value ms-2"
                  [icon]="'magnifying-glass-chart'"
                  [tooltip]="'measure.valueCalculated' | translate"
                />
              }
            </td>
          }
          @if (showColumnsValue.paybackPeriod) {
            <td>
              <span
                [innerHtml]="
                  measure.paybackPeriodYears
                    | paybackPeriod: measure.investment : measure.costReduction : showPaybackPeriodInYearsOnly()
                "
              ></span>
            </td>
          }
          @if (showColumnsValue.energyReduction) {
            <td>
              @if (showM2Value) {
                @if (measure.electricityConsumptionReductionInKwh && measure.electricityConsumptionReductionInKwh > 0) {
                  @if (showEnergyIconValue) {
                    <cfp-icon [icon]="'bolt'" class="me-2" />
                  }
                  <cfp-measurement-kwh-per-square
                    [tooltip]="'energyUsage.electricity.decrease' | translate"
                    class="d-block text-nowrap"
                    [value]="measure.electricityConsumptionReductionInKwhM2"
                  />
                }
                @if (measure.gasConsumptionReductionInM3 && measure.gasConsumptionReductionInM3 > 0) {
                  @if (showEnergyIconValue) {
                    <cfp-icon [icon]="'fire'" class="me-2" />
                  }
                  <cfp-measurement-gas-per-square
                    [building]="buildingValue"
                    class="d-block text-nowrap"
                    [tooltip]="
                      'energyUsage.gas.decrease' | translate: { unit: this.unitsConversionHelper.gasUnitsText() }
                    "
                    [value]="measure.gasConsumptionReductionInM3M2"
                  />
                }
                @if (measure.heatConsumptionReductionInGJ && measure.heatConsumptionReductionInGJ > 0) {
                  @if (showEnergyIconValue) {
                    <cfp-icon [icon]="'heat'" class="me-2" />
                  }
                  <cfp-measurement-heat-per-square
                    [building]="buildingValue"
                    class="d-block text-nowrap"
                    [tooltip]="
                      'energyUsage.heat.decrease' | translate: { unit: this.unitsConversionHelper.heatUnits() }
                    "
                    [value]="measure.heatConsumptionReductionInGJM2"
                  />
                }
                @if (measure.oilConsumptionReductionInLiter && measure.oilConsumptionReductionInLiter > 0) {
                  @if (showEnergyIconValue) {
                    <cfp-icon [icon]="'oil-can'" class="me-2" />
                  }
                  <cfp-measurement-liter-per-square
                    [building]="buildingValue"
                    class="d-block text-nowrap"
                    [tooltip]="'energyUsage.oil.decrease' | translate: { unit: this.unitsConversionHelper.oilUnits() }"
                    [value]="measure.oilConsumptionReductionInLiterM2"
                  />
                }
                @if (measure.woodConsumptionReductionInM3 && measure.woodConsumptionReductionInM3 > 0) {
                  @if (showEnergyIconValue) {
                    <cfp-icon [icon]="'fire'" class="me-2" />
                  }
                  <cfp-measurement-wood-per-square
                    [building]="buildingValue"
                    class="d-block text-nowrap"
                    [tooltip]="
                      'energyUsage.wood.decrease' | translate: { unit: this.unitsConversionHelper.woodUnitsText() }
                    "
                    [value]="measure.woodConsumptionReductionInM3M2"
                  />
                }
                @if (measure.pelletConsumptionReductionInTons && measure.pelletConsumptionReductionInTons > 0) {
                  @if (showEnergyIconValue) {
                    <cfp-icon [icon]="'fire'" class="me-2" />
                  }
                  <cfp-measurement-pellet-per-square
                    [building]="buildingValue"
                    class="d-block text-nowrap"
                    [tooltip]="
                      'energyUsage.pellet.decrease' | translate: { unit: this.unitsConversionHelper.pelletUnits() }
                    "
                    [value]="measure.pelletConsumptionReductionInTons"
                  />
                }
                @if (measure.coalConsumptionReductionInTons && measure.coalConsumptionReductionInTons > 0) {
                  @if (showEnergyIconValue) {
                    <cfp-icon [icon]="'fire'" class="me-2" />
                  }
                  <cfp-measurement-coal-per-square
                    [building]="buildingValue"
                    class="d-block text-nowrap"
                    [tooltip]="
                      'energyUsage.coal.decrease' | translate: { unit: this.unitsConversionHelper.coalUnits() }
                    "
                    [value]="measure.coalConsumptionReductionInTonsM2"
                  />
                }
              } @else {
                @if (measure.electricityConsumptionReductionInKwh && measure.electricityConsumptionReductionInKwh > 0) {
                  <div class="text-nowrap" [tooltip]="'energyUsage.electricity.decrease' | translate">
                    @if (showEnergyIconValue) {
                      <cfp-icon [icon]="'bolt'" class="me-2" />
                    }
                    {{ measure.electricityConsumptionReductionInKwh | number: '1.0-0' }} kWh
                  </div>
                }
                @if (measure.gasConsumptionReductionInM3 && measure.gasConsumptionReductionInM3 > 0) {
                  <div
                    class="text-nowrap"
                    [tooltip]="
                      'energyUsage.gas.decrease' | translate: { unit: this.unitsConversionHelper.gasUnitsText() }
                    "
                  >
                    @if (showEnergyIconValue) {
                      <cfp-icon [icon]="'fire'" class="me-2" />
                    }
                    {{
                      measure.gasConsumptionReductionInM3
                        | gasUnitsConversion: buildingAddress.countryCode : buildingAddress.regionCode
                        | async
                        | number: '1.0-0'
                    }}
                    <span [innerHTML]="unitsConversionHelper.gasUnitsHtml()"></span>
                  </div>
                }
                @if (measure.heatConsumptionReductionInGJ && measure.heatConsumptionReductionInGJ > 0) {
                  <div
                    class="text-nowrap"
                    [tooltip]="
                      'energyUsage.heat.decrease' | translate: { unit: this.unitsConversionHelper.heatUnits() }
                    "
                  >
                    @if (showEnergyIconValue) {
                      <cfp-icon [icon]="'heat'" class="me-2" />
                    }
                    {{
                      measure.heatConsumptionReductionInGJ
                        | heatUnitsConversion: buildingAddress.countryCode : buildingAddress.regionCode
                        | async
                        | number: '1.0-0'
                    }}
                    <span [innerHTML]="unitsConversionHelper.heatUnits()"></span>
                  </div>
                }
                @if (measure.oilConsumptionReductionInLiter && measure.oilConsumptionReductionInLiter > 0) {
                  <div
                    class="text-nowrap"
                    [tooltip]="'energyUsage.oil.decrease' | translate: { unit: this.unitsConversionHelper.oilUnits() }"
                  >
                    @if (showEnergyIconValue) {
                      <cfp-icon [icon]="'oil-can'" class="me-2" />
                    }
                    {{
                      measure.oilConsumptionReductionInLiter
                        | oilUnitsConversion: buildingAddress.countryCode : buildingAddress.regionCode
                        | async
                        | number: '1.0-0'
                    }}
                    <span [innerHTML]="unitsConversionHelper.oilUnits()"></span>
                  </div>
                }
                @if (measure.woodConsumptionReductionInM3 && measure.woodConsumptionReductionInM3 > 0) {
                  <div
                    class="text-nowrap"
                    [tooltip]="
                      'energyUsage.wood.decrease' | translate: { unit: this.unitsConversionHelper.woodUnitsText() }
                    "
                  >
                    @if (showEnergyIconValue) {
                      <cfp-icon [icon]="'fire'" class="me-2" />
                    }
                    {{
                      measure.woodConsumptionReductionInM3
                        | woodUnitsConversion: buildingAddress.countryCode : buildingAddress.regionCode
                        | async
                        | number: '1.0-0'
                    }}
                    <span [innerHTML]="unitsConversionHelper.woodUnitsHtml()"></span>
                  </div>
                }
                @if (measure.pelletConsumptionReductionInTons && measure.pelletConsumptionReductionInTons > 0) {
                  <div
                    class="text-nowrap"
                    [tooltip]="
                      'energyUsage.pellet.decrease' | translate: { unit: this.unitsConversionHelper.pelletUnits() }
                    "
                  >
                    <cfp-icon [icon]="'fire'" class="me-2" />
                    {{
                      measure.pelletConsumptionReductionInTons
                        | pelletUnitsConversion: buildingAddress.countryCode : buildingAddress.regionCode
                        | async
                        | number: '1.0-0'
                    }}
                    <span [innerHTML]="unitsConversionHelper.pelletUnits()"></span>
                  </div>
                }
                @if (measure.coalConsumptionReductionInTons && measure.coalConsumptionReductionInTons > 0) {
                  <div
                    class="text-nowrap"
                    [tooltip]="
                      'energyUsage.coal.decrease' | translate: { unit: this.unitsConversionHelper.coalUnits() }
                    "
                  >
                    @if (showEnergyIconValue) {
                      <cfp-icon [icon]="'fire'" class="me-2" />
                    }
                    {{
                      measure.coalConsumptionReductionInTons
                        | coalUnitsConversion: buildingAddress.countryCode : buildingAddress.regionCode
                        | async
                        | number: '1.0-0'
                    }}
                    <span [innerHTML]="unitsConversionHelper.coalUnits()"></span>
                  </div>
                }
              }
            </td>
          }
          @if (showColumnsValue.investor) {
            <td>
              @if (measure.investor) {
                {{ `investor.${measure.investor}` | translate }}
              } @else {
                <span [innerHtml]="'-' | ariaLabel: ('notApplicable' | translate)"></span>
              }
            </td>
          }
          @if (showColumnsValue.co2) {
            <td class="text-nowrap">
              @if (showM2Value) {
                <cfp-measurement-mass-per-square [value]="measure.co2ConsumptionReductionM2" [addCo2]="false" />
              } @else {
                <span [innerHtml]="measure.co2ConsumptionReduction | co2: false"></span>
              }
              @if (showCalculatedValueIcon && measure.buildingMeasureType === BuildingMeasureTypeDTO.CALCULATED) {
                <cfp-icon
                  class="icon-calculated-value ms-2"
                  [icon]="'magnifying-glass-chart'"
                  [tooltip]="'measure.valueCalculated' | translate"
                />
              }
            </td>
          }
          @if (showColumnsValue.impactEnergyLabel) {
            <td>
              @if (impactEnergyLabelAsProgress() && labelGroupValue) {
                <cfp-progress-bar
                  [percentage]="
                    10 *
                    (measure.userDefinedImpactEnergyLabels?.[labelGroupValue] ||
                      measure.impactEnergyLabels?.[labelGroupValue] ||
                      0)
                  "
                  [useGradient]="true"
                />
              } @else if (labelGroupValue) {
                <div class="text-nowrap d-flex">
                  <span
                    [innerHtml]="
                      measure.userDefinedImpactEnergyLabels?.[labelGroupValue] ||
                        measure.impactEnergyLabels?.[labelGroupValue] | labelImpactBar
                    "
                  ></span>
                  @if (
                    showCalculatedValueIcon &&
                    measure.buildingMeasureType === BuildingMeasureTypeDTO.CALCULATED &&
                    !measure.userDefinedImpactEnergyLabels?.[labelGroupValue]
                  ) {
                    <cfp-icon class="icon-calculated-value ms-2" [icon]="'magnifying-glass-chart'" />
                  }
                </div>
              }
            </td>
          }
          @if (showColumnsValue.status) {
            <td (click)="canEditMeasureValue && $event.stopPropagation()">
              @if (canEditMeasureValue) {
                <cfp-measure-status-dropdown
                  class="d-block"
                  [id]="`measureStatusDropdown${measure.id}`"
                  [disabled]="measure.loading || !canUpdateMeasureStatus()"
                  [ngModel]="measure.status"
                  (ngModelChange)="saveStatus(measure, $event)"
                  [formControlSize]="showAsCardValue ? 'default' : 'small'"
                  [dropup]="
                    filteredBuildingMeasuresValue
                      ? index === filteredBuildingMeasuresValue!.length - 1
                        ? true
                        : undefined
                      : undefined
                  "
                />
              } @else {
                <ng-container [ngTemplateOutlet]="measureStatus" [ngTemplateOutletContext]="{ measure: measure }" />
              }
            </td>
          }
          @if (showColumnsValue.implementationYear) {
            <td (click)="$event.stopPropagation()">
              @if (canEditMeasureValue) {
                <cfp-select-year
                  [startYear]="startYear"
                  [endYear]="endYear"
                  [name]="`${measure.code}YearSelect`"
                  [dataTest]="'measureYearSelect'"
                  [disabled]="measure.loading || !canUpdateMeasureStatus()"
                  [classes]="'roadmap-implementation-year-select'"
                  [ngModel]="measure.implementationYear"
                  (ngModelChange)="saveImplementationYear(measure, $event)"
                  [formControlSize]="showAsCardValue ? 'default' : 'small'"
                />
              } @else {
                @if (measure.implementationYear) {
                  <span>{{ measure.implementationYear }}</span>
                } @else {
                  <span class="text-nowrap">{{ 'noYear' | translate }}</span>
                }
              }
            </td>
          }
          @if (showColumnsValue.inPackage) {
            <td (click)="$event.stopPropagation()">
              <div class="btn-group toggle-buttons" [attr.data-test]="`measureStatusValue_${measure.status}`">
                <button
                  type="button"
                  class="btn {{ measure.status === MeasureStatusDTO.PLANNED ? 'btn-outline-primary' : 'btn-primary' }}"
                  (click)="saveStatus(measure, MeasureStatusDTO.PLANNED)"
                  [disabled]="measure.loading"
                  [attr.data-test]="`measureStatus_${measure.code}_PLANNED`"
                >
                  {{ 'yes' | translate }}
                </button>
                <button
                  type="button"
                  class="btn {{ measure.status === MeasureStatusDTO.DONE ? 'btn-outline-primary' : 'btn-primary' }}"
                  (click)="saveStatus(measure, MeasureStatusDTO.DONE)"
                  [disabled]="measure.loading"
                  [attr.data-test]="`measureStatus_${measure.code}_DONE`"
                >
                  {{ 'haveAlready' | translate }}
                </button>
                <button
                  type="button"
                  class="btn {{
                    measure.status === MeasureStatusDTO.OUTOFSCOPE ? 'btn-outline-primary' : 'btn-primary'
                  }}"
                  (click)="saveStatus(measure, MeasureStatusDTO.OUTOFSCOPE)"
                  [disabled]="measure.loading"
                  [attr.data-test]="`measureStatus_${measure.code}_OUT_OF_SCOPE`"
                >
                  {{ 'no' | translate }}
                </button>
              </div>
            </td>
          }
          @if (showColumnsValue.seeDetailsLink) {
            <td>
              <cfp-link
                (clicked)="showDetails(measure, index, $event)"
                [classes]="showAsCardValue ? 'w-100' : 'text-nowrap'"
                [buttonStyle]="showAsCardValue ? 'secondary' : undefined"
                [buttonOutline]="showAsCardValue ? true : false"
                >{{ 'seeDetails' | translate }}
                @if (!showAsCardValue) {
                  <cfp-icon [icon]="'chevron-right'" />
                }
              </cfp-link>
            </td>
          }
        </tr>
      </ng-template>
      <ng-container footer>
        <ng-content select="[footer]" />
      </ng-container>
    </lib-data-table>
  }
  @if (!loading() && (showLegend() || (showAll() && canShowAll()) || (showAddButton() && licensesValue.roadmap))) {
    <div class="row mt-4 building-measure-overview-footer">
      @if (showLegend()) {
        <div
          class="col-12 col-md-auto building-measures-overview-legend justify-content-center d-flex d-md-block align-items-center mb-3 mb-md-0"
        >
          @if (showCalculatedValueIcon) {
            <div class="me-4 me-md-0">
              <cfp-icon class="icon-calculated-value me-2" [icon]="'magnifying-glass-chart'" />{{
                'measure.valueCalculated' | translate
              }}
            </div>
          }
          @if (hasRecognizedMeasuresVisible() && environment.components.showRecognisedMeasureCheck) {
            <div class="me-4 me-md-0">
              @if (environment.icons.iconRecognizedMeasure) {
                <!-- Custom icon -->
                <span [ngClass]="environment.icons.iconRecognizedMeasure"></span>
                <!-- /Custom icon -->
              } @else {
                <!-- Default icon -->
                <div class="recognized-measure-table-icon">
                  <i class="fa fa-file-text-o fa-lg" aria-hidden="true"></i>
                  <span class="fa-stack fa-check-measure">
                    <i class="fa fa-circle fa-stack-1x"></i>
                    <i class="fa fa-check fa-stack-1x fa-inverse"></i>
                  </span>
                </div>
                <!-- /Default icon -->
              }
              <span class="ms-2">{{ 'measure.recognized' | translate }}</span>
              <cfp-info-modal-button class="ms-2" [title]="'measure.recognized'" body="measure.recognized.info" />
            </div>
          }
          @if (hasSubsidyLicense() && buildingIdValue && filteredBuildingMeasuresValue) {
            @defer {
              <cfp-subsidy-measure-legend [buildingId]="buildingIdValue" [measures]="filteredBuildingMeasuresValue" />
            }
          }
          @if (hasSubsidizedMeasuresVisible() && showSubsidyIcon()) {
            <div class="me-4 me-md-0">
              <i [ngClass]="environment.icons.iconSubsidy" aria-hidden="true"></i>
              <span class="ms-2">{{ 'measure.subsidized' | translate }}</span>
            </div>
          }
          @if (hasUserDefinedMeasuresVisible() && environment.icons.iconUserDefinedMeasure) {
            <div>
              <i [ngClass]="environment.icons.iconUserDefinedMeasure" aria-hidden="true"></i>
              <span class="ms-2">{{ 'measure.userDefined' | translate }}</span>
            </div>
          }
          @if (hasCustomerMeasuresVisible() && environment.icons.customerMeasureIcon) {
            <div>
              <i [ngClass]="environment.icons.customerMeasureIcon" aria-hidden="true"></i>
              <span class="ms-2">{{ 'measure.customer' | translate }}</span>
            </div>
          }
        </div>
      }
      <div class="col-12 col-md text-center">
        @if (showAll() && canShowAll()) {
          <cfp-button
            [buttonOutline]="true"
            [buttonStyle]="allMeasuresButtonStyle() === 'secondary' ? 'secondary' : 'primary'"
            class="d-print-none"
            classes="me-0 me-lg-3 w-lg-auto mb-3 mb-lg-0"
            (clicked)="changeScenario('allMeasures')"
            data-test="showAllMeasures"
          >
            {{ 'scenario.allmeasures' | translate }}<i class="fa fa-chevron-down ms-2" aria-hidden="true"></i>
          </cfp-button>
        }
        @if (showAddButton() && licensesValue.roadmap) {
          <cfp-button
            [buttonOutline]="true"
            buttonStyle="secondary"
            class="d-print-none"
            classes="me-0 me-lg-3 w-lg-auto mb-3 mb-lg-0"
            (clicked)="addNewMeasure()"
          >
            @if (environment.icons.iconUserDefinedMeasure) {
              <i class="me-2" [ngClass]="environment.icons.iconUserDefinedMeasure" aria-hidden="true"></i>
            }
            {{ 'measure.add' | translate }}
          </cfp-button>
        }
      </div>
      <div class="col-12 col-md-auto text-center text-md-end" #footerRight>
        <ng-content select="[footer-right]" />
      </div>
    </div>
  }
}

<ng-template #measureStatus let-measure="measure">
  @switch (measure.status) {
    @case (MeasureStatusDTO.DONE) {
      <span>{{ 'measureStatus.DONE' | translate }}</span>
    }
    @case (MeasureStatusDTO.PLANNED) {
      <span>{{ 'measureStatus.PLANNED' | translate }}</span>
    }
    @case (MeasureStatusDTO.OUTOFSCOPE) {
      <span>{{ 'measureStatus.OUTOFSCOPE' | translate }}</span>
    }
  }
</ng-template>
